import Web3 from 'web3'
import ProviderEngine from 'web3-provider-engine/dist/es5'
//import CacheSubprovider from 'web3-provider-engine/subproviders/cache.js'
import FilterSubprovider from 'web3-provider-engine/dist/es5/subproviders/filters.js'
import ProviderSubprovider from "web3-provider-engine/dist/es5/subproviders/provider.js";
import EventHookSubprovider from './event-hook-subprovider';

var web3;

export default ({ window, config }) => new Promise(function (resolve, reject) {

  function complete() {
    if (web3) {
      resolve(web3);
    } else {
      reject(new Error("Web3 not present."));
    }
  }

  function initializeAlephWallet(provider) {
    if (provider.setName && config && config.web3 && config.web3.name) {
      provider.setName(config.web3.name);
    }
    if (provider.setReloadOnNetworkChange) {
      provider.setReloadOnNetworkChange(false);
    }
  }

  if (typeof web3 !== 'undefined') {
    complete();
  } else {
    if (window && window.addEventListener) {
      window.addEventListener('load', function () {

        var provider = (window.web3 && window.web3.currentProvider);

        if (typeof provider !== 'undefined') {

          console.log('Injected ethereum provider detected.');
          initializeAlephWallet(provider);
          // Use the injected provider, but our version of web3
          var engine = new ProviderEngine({
            pollingInterval: 1000
          });
          engine.addProvider(new FilterSubprovider({ maxFilters: 10000 }));
          var events = new EventHookSubprovider();
          engine.addProvider(events);
          engine.addProvider(new ProviderSubprovider(provider));

          engine.start();
          web3 = new Web3(engine);
          web3.events = events;

        } else {
          console.log('No ethereum provider injected.');
        }

        complete();
      })
    }
  }
})


// WEBPACK FOOTER //
// ./src/api/web3.js